module.exports = __webpack_public_path__ + "img/circle-postcard.a69a2053.svg";